export const ChevronLeftBoldIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6 8.99319L10.58 4.36719L12 5.77419L8.815 8.99419L12.002 12.2122L10.581 13.6192L6 8.99319Z"
      fill="#000624"
    />
  </svg>
);
